import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const cellHead = [
  {
    headerName: 'Date',
    field: 'eventLoggedDate',
    editable: false,
    minWidth: Styles.Width_120,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Time',
    field: 'eventTime',
    editable: false,
    cellRenderer: 'timeRenderName',
    minWidth: Styles.Width_120,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      defaultOption: 'contains',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: false,
    },
  },
  {
    headerName: 'User ID',
    field: 'userId',
    editable: false,
    resizable: true,
    cellRenderer: 'userRenderName',
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    minWidth: Styles.Width_150,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  // {
  //   headerName: 'User Name',
  //   field: 'userName',
  //   editable: false,
  //   cellStyle: { 'border-right-color': Styles.BorderColor },
  //   cellRenderer: 'nameRenderName',
  //   cellClass: 'frr-ellipsis-text-overlap',
  //   minWidth: Styles.Width_150,
  //   filter: 'agTextColumnFilter',
  //   sortingOrder: ['desc', 'asc'],
  //   filterParams: {
  //     caseSensitive: false,
  //     defaultOption: 'startsWith',
  //     suppressAndOrCondition: true,
  //     buttons: ['reset'],
  //     refreshValuesOnOpen: true,
  //   },
  // },
  {
    headerName: 'Screen Name',
    field: 'portletName',
    editable: false,
    cellRenderer: 'screenRenderName',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-ellipsis-text-overlap',
    minWidth: Styles.Width_160,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  // {
  //   headerName: 'Field Type/Name',
  //   field: 'keyType',
  //   editable: false,
  //
  //   cellStyle: { 'border-right-color': Styles.BorderColor },
  //   cellClass: 'frr-ellipsis-text-overlap',
  //   filter: 'agTextColumnFilter',
  //   sortingOrder: ['desc', 'asc'],
  //   minWidth: Styles.Width_200,
  //   filterParams: {
  //     caseSensitive: false,
  //     defaultOption: 'startsWith',
  //     suppressAndOrCondition: true,
  //     buttons: ['reset'],
  //     refreshValuesOnOpen: true,
  //   },
  // },
  // {
  //   headerName: 'Field Value',
  //   field: 'key',
  //   editable: false,
  //   cellRenderer: 'keyRenderName',
  //   cellStyle: { 'border-right-color': Styles.BorderColor },
  //   filter: 'agTextColumnFilter',
  //   sortingOrder: ['desc', 'asc'],
  //   cellClass: 'frr-ellipsis-text-overlap',
  //   minWidth: Styles.Width_180,
  //   filterParams: {
  //     caseSensitive: false,
  //     defaultOption: 'startsWith',
  //     suppressAndOrCondition: true,
  //     buttons: ['reset'],
  //     refreshValuesOnOpen: true,
  //   },
  // },
];
export const claimHead = [
  {
    headerName: 'Claim ID',
    field: 'claimId',
    editable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_180,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim Line Num',
    field: 'claimLineNum',
    editable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    // cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const providerHead = [
  {
    headerName: 'Provider ID',
    field: 'key',
    editable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_125,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const ndcHead = [
  {
    headerName: 'NDC',
    field: 'key',
    editable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_200,
    filterParams: {
      caseSensitive: false,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
